import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { getUrlParam } from '.';
import { setLastOperateTime, getLastOperateTime, getTimeoutNum, getScopeParam, getMysteryCode } from './session/store';

// 配置常量
const CONFIG = {
    // 超时时间
    TIMEOUT_MINUTES: 30,
    // 加密密钥和IV - 建议移到环境变量中
    ENCRYPTION_KEY: 'dufy20210419java',
    ENCRYPTION_IV: 'dufy20210419java',
    // 重新扫描消息
    RESCAN_MESSAGE: `<div class="line-circle"></div><h1 class="text-center text-gray">QR code expired</h1><h1 class="text-center">Please rescan QR code</h1>`,
    // 白名单区域ID列表 - 建议移到配置文件或数据库中
    WHITE_LIST_AREA_IDS: [
        "e6b94a6b-a864-415d-9517-0e873b7f7095",
        "06e576f7-31b5-4ead-8aa7-26d1a83c3c98",
        "18efa0b1-041b-46c2-9c4b-b39fab02968d",
        "1c44e786-ba35-45bd-931e-71c0f06d60eb",
        "1c7c209e-455f-4d6a-b42c-08f523ea7a1d",
        "1f0c92e8-5244-4da2-a380-118eca04c2b2",
        "2b51b73d-9d11-4e0e-b782-d7597a7a9e9c",
        "343f4fd4-518b-47ba-b5f0-394c6f720b99",
        "4974ced0-64ab-41e8-aaa8-4ee2340cdf7f",
        "4a25625f-c2d6-498d-af1e-9234b52d48f5",
        "52f5ca59-f7ac-4b4b-8cc7-4a15a2ce12fe",
        "541420e8-5243-4a8e-9bd6-58d5a5568faa",
        "58bdc23a-8f20-4e33-bb6a-e221c5ef8b7c",
        "61a915cd-2131-4ee6-85ec-b768469d4a2e",
        "62b91932-5cc7-4f49-ab0b-5e6031986935",
        "68def976-6ac5-424d-bfd3-5dc6457fda05",
        "6a261d74-168e-4eb2-9848-7cff66520b81",
        "6db03cc1-c58d-4890-9b2d-1531ba665031",
        "7c93b336-a95e-4bb8-939a-c273af33a10f",
        "7eaaa3b6-599e-408c-a8f0-a811a8afc206",
        "872d25b5-aa83-461d-9276-a1bebf7ea768",
        "88573304-294b-4e57-bbb7-59456b7de6c0",
        "8c8126b1-aae3-4d60-8c68-dd1cbe58b53e",
        "8e6c3335-b617-491b-9f61-7bd6d9df0ff3",
        "9dba4b1d-99bb-48d1-844e-d6782b07d88b",
        "9e486be3-77b3-4f01-b087-27618d0a436a",
        "a3f96705-0470-4294-bc52-95fff7144d71",
        "a71c8167-b1dc-4ca4-bacb-08ec902eb5ee",
        "b3275ee8-96a2-4b72-b3ed-01d816da152a",
        "b877557b-b50c-4bed-b08e-b9a3bf1ed5c1",
        "ce29b413-09dd-4dbf-a75f-03e06983d5ec",
        "d2751770-bedf-4265-922c-57b23dee5399",
        "d68ad599-e44c-4af5-8b39-457fec17acb1",
        "de6a7afd-29dc-4b19-bc71-98e20d6e21c6",
        "edebeabb-64c8-46ac-9cc5-66589a8807fe",
        "eed5bddf-6231-45f5-9709-4f25ca8c92b3",
        "f78da6a2-3aec-4483-8efa-878b61299956",
        "fa4347aa-8a87-4a03-814f-e6bcb671bbc3",
        "7ef8dce5-49ac-4d99-b4c7-309a636a6d23",
        "e7fead72-b994-4803-a55f-a7ba43f2a9a8",
        "f01dc2be-d915-41d2-a33b-03b1220f3a62",
        "36d62ee0-ac05-4dfe-8cd1-da94add190cc",
        "a37706ac-4995-4cf3-a053-e5d824f8a82f",
        "8c0e4259-5b68-4469-83ce-78bdb6ee1897",
        "4411c1c0-7b8a-41d8-8fd3-25db06edbfb8",
        "85884995-2bf7-4789-b195-0a2e008726c8",
        "211d7780-45f7-45f7-aaea-155a347ca98c",
        "018f6c16-5759-4879-adb3-c6ab0de2fe71",
        "e324b260-6dba-47d3-9fb6-257f10d8a42d",
        "fbe69de9-de7e-4d06-92ef-b646dc21d3e2",
        "7a5b209b-b27f-4d3c-8dfa-d603d13c7c53",
        "c083ff19-95c7-4ebc-9358-94635087dae7",
        "a2c16911-4529-40bd-ac68-db8e5bcfb51b",
        "2fd4b5e5-26ff-4d7d-9a6c-fd59a332f80d",
        "a1f8983e-1230-4a73-9c6b-f5d47c32ad0e",
        "00314216-a7f4-4afa-9d7d-811f7599ba2a",
        "472a7882-de83-4faf-bfb7-08662c81af8d",
        "ad932624-fb3b-4902-b063-d71189272026",
        "9cc7c778-b311-49d8-b652-4028f9361227",
        "c44e860f-f9fd-474d-b497-b5aedafcdfb3",
        "fdfeeec5-120b-4a33-9cb1-1c8025b0b100",
        "31cd9160-0a60-4ebc-974b-d38a0704696d",
        "98761e6b-7b55-41e2-b955-5f33b9f3959f",
        "bd1f8c83-1564-4cd5-b95e-635806d23959",
        "6a1f6ff2-c0c7-4141-a7e8-c727462e8eed",
        "0fb1dbff-618c-4f02-a2e4-cd1060c230d1",
        "1cc2090f-6bee-4a32-aacf-1901e8765ad3",
        "7331aed2-ffb9-4243-83f8-da179c2f52c4",
        "4262644d-5c9a-4a70-8da5-a0a5a011b278",
        "5d35f636-5769-4c26-85b0-ec07f3d13e65",
        "7c32a6a3-a663-4782-8560-c89f4352652b",
        "5507eb06-cf52-413f-b0fb-8bf4afdf33cc",
        "4a30ee1d-b5ff-4411-99c5-ac2bfe5ce331",
        "e90cd1c7-e9c6-4175-9bd6-c102f3849018",
        "5268584c-4641-4b2b-8967-c8ab3ad4962e",
        "f27917f9-cf26-4721-bd2f-d89031189644",
        "9cd93685-e66d-47c7-b06a-2fb43dfa97c5",
        "802454a4-6f29-4504-9b3f-ae4469e7ba92",
        "ad56f8c3-b55c-4cc8-b328-cb4ef69bce86",
        "4edc3aa8-2110-4616-921b-abd332cb4360",
        "270a1c5e-4e44-4e76-a3f8-7764afca0024",
        "59833bbc-64c0-4305-87cf-0703d183661a",
        "9b8800b7-17f9-4d29-8237-e6036e420ccd",
        "f85867fd-72c0-4eae-ad9b-9846c9b1d899",
        "831c183c-071d-4e84-b4f4-ab4ef960e0e1",
        "b2158537-f925-4acc-b549-b88c1933b893",
        "1b78a1c5-eb12-44f7-94a6-c084b69d72b4",
        "4f8fb59d-1aae-4dcc-b461-2245f6d51e5c",
        "05632477-6d27-42ec-b550-424a9388b8bb",
        "ffcd7f18-3efb-4904-9090-d9ff3b53d0c2",
        "16593a13-88b7-4f5f-9d49-1d206853ac83",
        "e3411c66-0aa5-4826-ba32-8ad812b91ea1",
        "c85b8734-d7b6-43e6-96c2-d0ccc1d2e863",
        "178b7364-8d3a-44fe-ae25-b40f7101ce2a",
        "17a17b8f-751f-44e2-a1d8-e7e6de409ad8",
        "93ae9df5-33b3-4940-bb78-79be9973f258",
        "de34ccb0-c338-4c75-8e0c-a9a3fc5e0e8e",
        "9527c34c-e0cb-41ca-bad2-5f888154d3e6",
        "d449b0cc-b93c-42c8-ba01-9cd8883fcec3",
        "9e07dee0-32ec-44cb-89de-1a84922dcf24",
        "b68ac144-e5ec-4d98-af9e-fb7e44766dcd",
        "9a96ed64-109d-4a86-971d-1bcc743ef0ca",
        "74790445-ec34-427f-afa0-a74a6d8362c7",
        "8c9f89c4-67d8-4cbf-9066-444037def17a",
        "7b907843-4e5b-4880-aecd-a8891c701da8",
        "91853ae0-8b0c-4c6a-a8c5-57df576123e0",
        "a6a65edf-b9c0-43c6-bbb5-3279177fe96f",
        "5f295ed6-3591-4ae3-bdb6-27bd87f4c5f8",
        "3a6e1a1b-7693-42de-943b-b12ac975136c",
        "39452059-16ad-47ef-b346-0edda3801d93",
        "dac3e589-0886-4977-9e8b-055e6878605c",
        "93f00921-bf5d-4e78-8494-ef4d8cc1a4d9",
        "2a0be322-b68a-405c-82d1-862581655bd0",
        "1b0b2e87-9966-4c3b-9ca3-b12ff92e55a5",
        "35e77f2f-e39e-48fc-ad21-b4d10fb21f58",
        "03d30601-5a7d-408e-8fd2-3a6a0c320194",
        "3625cac2-b216-4fe5-b66c-94eb6f375680",
        "ddb57279-a95e-4261-8b03-56317b0b6286",
        "3dd4d675-935f-4400-bd58-4a368e592398",
        "804b6607-6ba3-4c43-bdfc-6e3766d2d9a9",
        "9dcb9b58-d96b-4184-9780-bfe5523d5577",
        "e5e82bb5-ef0c-495a-96da-aa4a7e949ef6",
        "ce6ffae0-26d0-4dd1-bbca-87549ac40300",
        "ffbc4a38-b37d-4f0a-af9a-271ef560a46f",
        "b43b000a-9566-4700-8c88-a1c7cc7675cc",
        "6a066895-2e26-41ad-ab0c-611093ea6410",
        "73013acf-609b-4886-82b8-8d3182747c4d",
        "f9b558a3-2d26-4880-a4a3-18a53107d377",
        "eee9d900-0435-4fe0-99a5-749603ecc26a",
        "81608f28-c33f-40e1-89ef-f58fc5513284",
        "02a78507-f542-4d5b-bf78-fb1a9c9f832f"
    ]
};

// 状态管理
let isInitialized = false;
let clickHandler = null;

/**
 * 检查是否需要扫描
 * @returns {boolean} 是否需要扫描
 */
function shouldScan() {
    const scopeParam = getScopeParam() || {};
    const areaId = scopeParam.areaId || getUrlParam('areaid');
    return !areaId || !CONFIG.WHITE_LIST_AREA_IDS.includes(areaId);
}

/**
 * 显示重新扫描消息
 */
function showRescanMessage() {
    if (document.body) {
        document.body.innerHTML = CONFIG.RESCAN_MESSAGE;
    }
}

/**
 * 检查是否超时
 * @param {Date} codeTime - 代码时间
 * @returns {boolean} 是否超时
 */
function isTimeout(codeTime) {
    const mCode = getMyLocalCode();
    if (!mCode) {
        return false;
    }

    const lastTime = codeTime || getLastOperateTime();
    const timeoutNum = getTimeoutNum() || CONFIG.TIMEOUT_MINUTES;

    if (!lastTime || timeoutNum <= 0) {
        return false;
    }

    const now = new Date();
    const timeout = dayjs(lastTime).add(timeoutNum, 'minutes').toDate();

    if (timeout < now) {
        showRescanMessage();
        return true;
    }

    return false;
}

/**
 * 处理点击事件
 */
function handleClick() {
    if (isTimeout()) {
        return;
    }
    // 更新最后操作时间
    setLastOperateTime(new Date());
}

/**
 * 添加点击事件监听器
 */
function addClickEvent() {
    if (clickHandler) {
        return; // 避免重复添加
    }

    clickHandler = handleClick;
    document.addEventListener('click', clickHandler);
}

/**
 * 移除点击事件监听器
 */
function removeClickEvent() {
    if (clickHandler) {
        document.removeEventListener('click', clickHandler);
        clickHandler = null;
    }
}

/**
 * 处理URL中的神秘代码
 * @param {string} urlCodeTime - URL中的神秘代码
 * @returns {boolean} 处理是否成功
 */
function processMysteryCode(urlCodeTime) {
    if (!urlCodeTime) {
        return false;
    }

    try {
        const urlTime = Number(AESUtils.decrypt(urlCodeTime, CONFIG.ENCRYPTION_KEY, CONFIG.ENCRYPTION_IV));
        const codeTime = new Date(urlTime);

        if (isNaN(codeTime.getTime())) {
            console.warn('Invalid date from mystery code:', urlTime);
            return false;
        }

        setLastOperateTime(codeTime);

        if (isTimeout(codeTime)) {
            return false;
        }

        addClickEvent();
        return true;

    } catch (error) {
        console.error('Error processing mystery code:', error);
        return false;
    }
}


const getMyLocalCode = () => {
    const urlCodeTime = getUrlParam('mysterycode') || getMysteryCode() || '';
    return urlCodeTime
}

/**
 * 初始化超时监控
 */
export function initWatchTimeout() {
    if (isInitialized) {
        console.warn('Timeout handler already initialized');
        return;
    }

    if (!shouldScan()) {
        isInitialized = true;
        return;
    }

    // 重置最后操作时间
    setLastOperateTime('');

    // 处理URL中的神秘代码
    const urlCodeTime = getMyLocalCode();
    const success = processMysteryCode(urlCodeTime);

    if (!success && urlCodeTime) {
        // 如果处理失败但有神秘代码，显示重新扫描消息
        showRescanMessage();
    }

    isInitialized = true;
}

/**
 * 清理超时监控
 */
export function cleanupTimeout() {
    removeClickEvent();
    isInitialized = false;
}

/**
 * 全局点击事件监听器，检测 mysterycode 是否过期
 * 如果过期，阻止点击事件并显示过期提示
 */
export function initGlobalClickTimeoutCheck() {
    // 防止重复绑定
    if (window._mysteryCodeClickHandler) {
        return;
    }

    const handleClick = (event) => {
        // 检查是否有 mysterycode 参数
        const result = isTimeout();

        if (result) {
            // 阻止事件继续传播
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            // 显示过期提示
            showRescanMessage();

            // 阻止默认行为
            return false;
        }

        setLastOperateTime(new Date());
    };

    // 绑定到 document 上，捕获所有点击事件
    document.addEventListener('click', handleClick, true);

    // 保存引用，用于后续清理
    window._mysteryCodeClickHandler = handleClick;

    console.log('全局点击事件超时检测已启用');
}

/**
 * 移除全局点击事件监听器
 */
export function removeGlobalClickTimeoutCheck() {
    if (window._mysteryCodeClickHandler) {
        document.removeEventListener('click', window._mysteryCodeClickHandler, true);
        delete window._mysteryCodeClickHandler;
        console.log('全局点击事件超时检测已移除');
    }
}


/**
 * AES加密工具类
 */
export const AESUtils = {
    /**
     * 加密数据
     * @param {string} data - 要加密的数据
     * @param {string} key - 加密密钥
     * @param {string} iv - 初始化向量
     * @returns {string} 加密后的base64字符串
     */
    encrypt(data, key, iv) {
        try {
            const encodedKey = CryptoJS.enc.Utf8.parse(key);
            const encodedIv = CryptoJS.enc.Utf8.parse(iv);
            const encodedData = CryptoJS.enc.Utf8.parse(data);

            const encrypted = CryptoJS.AES.encrypt(encodedData, encodedKey, {
                iv: encodedIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.NoPadding
            });

            return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
        } catch (error) {
            console.error('Encryption failed:', error);
            throw new Error('Encryption failed');
        }
    },

    /**
     * 解密数据
     * @param {string} data - 要解密的数据
     * @param {string} key - 解密密钥
     * @param {string} iv - 初始化向量
     * @returns {string} 解密后的字符串
     */
    decrypt(data, key, iv) {
        try {
            const encodedKey = CryptoJS.enc.Utf8.parse(key);
            const encodedIv = CryptoJS.enc.Utf8.parse(iv);

            // 处理URL安全的base64编码
            const base64Str = data.replace(/_/g, '/').replace(/-/g, '+');

            const decrypt = CryptoJS.AES.decrypt(base64Str, encodedKey, {
                iv: encodedIv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.NoPadding
            });

            const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
            return decryptedStr.replace(/\x00/g, '');
        } catch (error) {
            console.error('Decryption failed:', error);
            throw new Error('Decryption failed');
        }
    }
};